import React from 'react';
import * as PropTypes from 'prop-types';
import Button from '../../common/Button';
import SecurityGroupForm from '../../SsoCreate/SecurityGroupForm';
import { buttonStyles, cardHeaderStyles, cardStyles, cardTitleStyles } from './styles/CreateSecurityGroup.css';
import { ButtonTypes, Modes } from '../../../constants/Enums';

const SecurityGroupDetails = (props) => {
    let title;
    switch (props.mode) {
        case Modes.COPY: {
            title = 'Copy Security Group';
            break;
        }
        case Modes.EDIT: {
            title = 'Edit Security Group';
            break;
        }
        default: {
            title = 'Create Security Group';
            break;
        }
    }
    return (
        <div className="card" style={cardStyles}>
            <form onSubmit={props.handleSubmit}>
                <div className="card-header" style={cardHeaderStyles}>
                    <div className="row">
                        <div className="col-md-4">
                            <h4 className="card-title" style={cardTitleStyles}>
                                {title}
                            </h4>
                        </div>
                        <div className="col-md-3 offset-md-5">
                            <div className="btn-group float-right">
                                <Button
                                    text="Cancel"
                                    type={ButtonTypes.SECONDARY}
                                    additionalStyles={buttonStyles}
                                    action={props.cancel}
                                />
                                <Button text="Save" type={'submit'} additionalStyles={buttonStyles}
                                        disabled={props.buttonIsDisabled()} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="container">
                        <SecurityGroupForm disabled={props.disabled} />
                    </div>
                </div>
            </form>
        </div>
    );

};

SecurityGroupDetails.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    buttonIsDisabled: PropTypes.func.isRequired,
    cancel: PropTypes.func.isRequired,
    mode: PropTypes.number,
    disabled: PropTypes.bool
};

export default SecurityGroupDetails;
